
module.exports = global.config = {
       gtmId: "GTM-MRSZ7PG"                // prod

};



